import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(17, 24, 39, 0.8);
    display: flex; justify-content: center; align-items: center;
    z-index: 2000;
`;

const ModalContent = styled.div`
    background-color: ${props => props.theme.colors.surface};
    padding: 2.5rem;
    border-radius: 8px;
    width: 90%;
    max-width: 650px;
`;

const ModalTitle = styled.h3`
    font-family: ${props => props.theme.typography.titleFamily};
    font-size: 1.5rem;
    color: ${props => props.theme.colors.primary};
    margin: 0 0 1.5rem 0;
`;

const InstructionsList = styled.ol`
    padding-left: 1.5rem;
    margin: 0 0 2rem 0;
    line-height: 1.8;
`;

const InstructionItem = styled.li`
    margin-bottom: 0.75rem;
    color: ${props => props.theme.colors.secondary};
`;

const CodeText = styled.code`
    background-color: ${props => props.theme.colors.background};
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    font-family: monospace;
`;

const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
`;

const Button = styled.button`
    font-family: ${props => props.theme.typography.fontFamily};
    background-color: ${props => props.primary ? props.theme.colors.primary : props.theme.colors.lightGray};
    color: ${props => props.primary ? props.theme.colors.textPrimary : props.theme.colors.secondary};
    border: none;
    border-radius: ${props => props.theme.borderRadius};
    padding: 0.75rem 1.5rem;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
`;

const InstructionsModal = ({ isOpen, onClose, onContinue }) => {
    if (!isOpen) return null;

    const handleContinue = () => {
        onClose();
        onContinue();
    };

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent className="axon-modal-sheet" onClick={(e) => e.stopPropagation()}>
                <ModalTitle>Instrucciones para Obtener el Archivo de Saldos</ModalTitle>
                <InstructionsList>
                    <InstructionItem>Ingresar a <a href="https://agentes.rosval.com.ar/Irmo/" target="_blank" rel="noopener noreferrer">https://agentes.rosval.com.ar/Irmo/</a></InstructionItem>
                    <InstructionItem>Dirigirse a <CodeText>Gestión bursátil &gt; Consultas &gt; Consulta de consolidados generales (AN/AP)</CodeText></InstructionItem>
                    <InstructionItem>
                        Cargar los siguientes filtros:
                        <ul>
                            <li><CodeText>Tipos de cuenta:</CodeText> "Comitente" y "Comitente AN"</li>
                            <li>Borrar el campo <CodeText>Liquidación desde</CodeText></li>
                            <li>En el campo <CodeText>Liquidación hasta</CodeText> ingresar la fecha de hoy</li>
                            <li>En el campo <CodeText>Nivel</CodeText> seleccionar: "Cuenta"</li>
                        </ul>
                    </InstructionItem>
                    <InstructionItem>Presionar <CodeText>Consultar</CodeText></InstructionItem>
                    <InstructionItem>Click derecho sobre la tabla &gt; <CodeText>Exportar como XLSX</CodeText></InstructionItem>
                </InstructionsList>
                <ModalActions className="axon-modal-actions">
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button primary onClick={handleContinue}>Continuar y Cargar Archivo</Button>
                </ModalActions>
            </ModalContent>
        </ModalOverlay>
    );
};

export default InstructionsModal;
